module.exports = __webpack_public_path__ + "img/phonograph_jg.2ef00729.png";